<template>
    <v-container fluid>
      <vueHeadful
      :title="this.$i18n.t('Menu.QuienesSomos') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
          <v-col style="padding: 60px 10% 0" cols="12" align="center">
            <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.QuienesSomos')}}</h1>
          </v-col>
        </v-row>
        <v-row style="background:#4180FF;padding: 80px 0;margin:40px 0;">
          <v-col cols="12" style="padding: 0 10%" align="center">
            <p style="font-size:20px;line-height:40px;color:white;">{{$t('Alerta.QuienesSomos')}}</p>
            <br>
            <p style="font-size:20px;color:white;"><b>{{$t('Alerta.QuienesSomos2')}}</b></p>
          </v-col>
        </v-row>
        <v-row style="margin: 60px 10% 0">
            <v-col cols="12">
              <div class="textoMagazine" v-html="contenidoEs" v-if="getIdioma === 'es'" />
              <div class="textoMagazine" v-html="contenidoEn" v-else />
            </v-col>
        </v-row>
        <v-row style="padding: 0 10% 120px">
          <v-col v-for="(i, index) in equipo" :key="index" cols="12" xs="12" md="4" style="padding: 40px 2%" align="center">
            <v-card elevation="10">
              <v-card-title>
                <v-container>
                  <v-row>
                    <v-col align="center">
                      <v-avatar title size="240">
                        <v-img :src="i.src"></v-img>
                      </v-avatar>
                      <h3 class="my-5">{{i.nombre}}</h3>
                      <p style="font-weight: 600;">{{i.descripcion}}</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>
              <v-card-text>
                <v-row style="padding: 0 8% 50px" justify = 'center' align="center" class="mx-0">
                  <p class="card-text mt-1" v-if="getIdioma === 'es'">{{i.resenaEs}}</p>
                  <p class="card-text mt-1" v-if="getIdioma === 'en'">{{i.resenaIn}}</p>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
export default {
  name: 'QuienesSomos',
  mounted () {
    firebase.firestore().collection('utilidades').doc('quienesSomos').get().then(info => {
      this.contenidoEs = info.data().contenidoEs
      this.contenidoEn = info.data().contenidoEn
      this.equipo = info.data().equipo
    })
  },
  data () {
    return {
      contenidoEs: '',
      contenidoEn: '',
      equipo: []
    }
  },
  computed: {
    ...mapGetters(['getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>
<style scoped>
.card-text {
  font-size: 1.15rem;
  font-weight: 400;
  word-break: keep-all;
  text-align: justify;

}
</style>
